import * as moment from 'moment';
import {OnInit} from '@angular/core';
import { DATE_DEFAULT_FORMAT } from '../model/commons/DateConstants';
import {FeatureAccessService} from './feature-access.service';

export class TimeZoneService implements OnInit{
  public tz = 0;
  public payload: { city: string; timeZone: number; timeZoneLabel: string } = {
    city: null,
    timeZone: 0,
    timeZoneLabel: null
  };
  public username = '';
  public timezones: Array<{ code: number; text: string }> = [
    {code: -12, text: "UTC -12:00"},
    {code: -11, text: "UTC -11:00"},
    {code: -10, text: "UTC -10:00"},
    {code: -9, text: "UTC -09:00"},
    {code: -8, text: "UTC -08:00"},
    {code: -7, text: "UTC -07:00"},
    {code: -6, text: "UTC -06:00"},
    {code: -5, text: "UTC -05:00"},
    {code: -4, text: "UTC -04:00"},
    {code: -3, text: "UTC -03:00"},
    {code: -2, text: "UTC -02:00"},
    {code: -1, text: "UTC -01:00"},
    {code: 0, text: "UTC   00:00"},
    {code: 1, text: "UTC +01:00"},
    {code: 2, text: "UTC +02:00"},
    {code: 3, text: "UTC +03:00"},
    {code: 4, text: "UTC +04:00"},
    {code: 5, text: "UTC +05:00"},
    {code: 6, text: "UTC +06:00"},
    {code: 7, text: "UTC +07:00"},
    {code: 8, text: "UTC +08:00"},
    {code: 9, text: "UTC +09:00"},
    {code: 10, text: "UTC +10:00"},
    {code: 11, text: "UTC +11:00"},
    {code: 12, text: "UTC +12:00"}
  ];

  constructor() {
  }
  ngOnInit(): void {
  }
  setUser(username?: string) {
    this.username = username;
    this.getTimeZoneByUser()
  }
  getTimeZoneByUser(useBrowser?) {
    const _tzBrowser = (new Date().getTimezoneOffset() / 60) * -1;
    this.tz = (typeof useBrowser == 'undefined' ? this.tz : _tzBrowser);
    this.payload.timeZone = this.tz;
    return this.tz;
  }

  GmtToLocale(date) {
    return moment(date).add(this.tz, 'hours').toDate()
  }

  LocaleToGmt(date) {
    return moment(date).subtract(this.tz, 'hours').format('YYYY-MM-DD HH:mm:ss')
  }

  getReopenFichePeriod(day1, day2, nbMois,currentDateFiche,country) {
    //country = "MU";day1 = 1; day2 = 31; nbMois = 1
    let date1 = null, date2 = null;
    let countryPayPeriodM_2 = ["MU","MG"];
    const currentDay = moment().date();
    const currentMonth = moment().month() + 1;
    const currentYear = moment().year()
    if (FeatureAccessService.hasAccess('REOPEN_FICHE_PERIOD',country.toUpperCase())){
      date1 = moment();
      date2 = moment();
      date1.set('date', day1);
      date1 = date1.subtract(nbMois+1, 'month');
      date1.subtract(1, 'month');
      if (!countryPayPeriodM_2.includes(country.toUpperCase()))
        date2 = date2.set('date', day2);
      else
        date2 = new Date(currentYear, date2.month()+1, 0);
      if (currentDateFiche.isAfter(date2))
      {
        if (countryPayPeriodM_2.includes(country.toUpperCase()))
          date1 = moment(date1).add(1, 'M');
        date2 = moment(date2).add(1, 'M');
      }
      return [moment(date1).format(DATE_DEFAULT_FORMAT), moment(date2).format(DATE_DEFAULT_FORMAT)];

    }else{
      if(day2 > currentDay){
        date2 = moment();
        date2.set('date', day2);
        if(day1 <= day2){
          date1 = moment().subtract(1, 'month');
          date1.set('date', day1+1);
        }else {
          date1 = moment().subtract(2, 'month');
          date1.set('date', day1+1);
        }
      }else {
        date2 = moment().add(1, 'month');
        date2.set('date', day2);
        if(day1 <= day2){
          date1 = moment();
          date1.set('date', day1+1);
        }else {
          date1 = moment().subtract(1, 'month');
          date1.set('date', day1+1);
        }
      }
    }

    date1 = date1.subtract(nbMois+1, 'month');

    return [moment(date1).format(DATE_DEFAULT_FORMAT), moment(date2).format(DATE_DEFAULT_FORMAT)];
  }

}



// WEBPACK FOOTER //
// ./src/app/service/TimeZoneService.ts